<div class="popup-content relative o-hidden box-popup">
    <div class="py-5 px-2-5 rounded-t relative o-hidden color-light-shadow-v2">
        <app-loader *ngIf="loading$ | async" loaderType="cover" overlayColor="white"></app-loader>
        <ng-container *ngIf="(loaded$ | async) && (loadedTrial$ | async); else loader">
            <div class="d-flex align-items-center mb-6">
                <div class="text-light-shadow-v2 text-22 font-bold text-center w-100" translate>v3-trial-invites-popup-title</div>
                <button
                    [attr.aria-label]="'v3-button-close' | translate"
                    class="btn-clear icon icon-s close-icon pointer ms-auto"
                    [inlineSVG]="'assets/icons.svg#close-simple'"
                    (click)="closePopup()"
                    buttonDataTest="closeButton"
                ></button>
            </div>

            <!-- Company -->
            <div class="row mx-0 align-items-center justify-content-center text-m font-bold mb-7">
                <div class="d-flex align-items-center company px-4 me-2">
                    <div translate>
                        {{ companyName }}
                    </div>
                </div>
                <span translate>v3-trial-invites-popup-on-social-talent</span>
            </div>

            <ng-container *ngIf="(addedUsers$ | async).length < (maxInvites$ | async); else reachedMaximumInvitees">
                <!-- User full name and Work email address -->
                <div>
                    <div class="row g-0">
                        <!-- Full name -->
                        <div class="col-12 position-relative col-md-5 pe-md-4 mb-2 mb-md-0">
                            <div class="d-flex align-items-center mb-2">
                                <div class="icon icon-s me-2 ms-4 text-light-shadow-v2" inlineSVG="assets/icons-color.svg#person"></div>
                                <div class="text-s font-bold d-flex">
                                    <span class="text-oneline" translate>v3-trial-invites-popup-full-name</span>
                                </div>
                            </div>

                            <div class="d-flex">
                                <div class="w-100">
                                    <input
                                        class="w-100 new-input"
                                        type="text"
                                        [ngClass]="{ danger: fullName.touched && fullName.invalid }"
                                        [formControl]="fullName"
                                        [placeholder]="'v3-trial-invites-popup-full-name-placeholder' | translate"
                                        formControlDataTest="fullnameInput"
                                    />
                                    <div *ngIf="fullName.touched && fullName.invalid" class="text-danger text-s mt-1" translate>
                                        v3-trial-invites-popup-full-name-error
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Work email address -->
                        <div class="col-12 position-relative col-md-7">
                            <div class="d-flex align-items-center mb-2">
                                <div class="icon icon-m ms-4 me-2" inlineSVG="assets/icons-color.svg#email"></div>
                                <div class="text-s font-bold d-flex">
                                    <span class="text-oneline" translate>v3-trial-invites-popup-email</span>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="w-100">
                                    <input
                                        class="w-100 new-input"
                                        type="text"
                                        [ngClass]="{ danger: email.touched && (email.invalid || companyHasEmail) }"
                                        [formControl]="email"
                                        [placeholder]="'email@companyname.com'"
                                        formControlDataTest="emailInput"
                                    />
                                    <div *ngIf="email.touched && (email.invalid || companyHasEmail)" class="text-danger text-s mt-1">
                                        {{ (companyHasEmail ? 'v3-trial-invites-popup-has-email-error' : 'v3-trial-invites-popup-email-error') | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Button -->
                    <div
                        *ngIf="showAddAnotherBtn"
                        [ngClass]="[hideAddAnotherBtn ? 'opacity-0' : 'opacity-1']"
                        class="row mx-0 align-items-center justify-content-end mt-3 theme-new"
                    >
                        <div class="d-inline me-3">
                            {{ 'v3-trial-invites-popup-remaining' | translate: { users: (maxInvites$ | async) - (addedUsers$ | async).length } }}
                        </div>
                        <button
                            class="btn text-s font-bold add-another-btn"
                            (click)="addAnother()"
                            [disabled]="!nameAndEmailValid"
                            [ngClass]="{ 'add-another-btn-disabled': !nameAndEmailValid }"
                            translate
                            buttonDataTest="addUsersButton"
                        >
                            v3-button-add
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-template #reachedMaximumInvitees>
                <div class="mt-8 mb-6 text-center text-s" translate>v3-trial-invites-popup-maximum</div>
            </ng-template>

            <!-- Invitees -->
            <div *ngIf="hasAddedUsers" class="my-4">
                <div class="row mx-0 align-items-center justify-content-between mb-3">
                    <div class="text-m font-bold" translate>v3-trial-invites-popup-invites</div>
                    <div *ngIf="!showAddAnotherBtn || hideAddAnotherBtn" class="text-s">
                        {{ 'v3-trial-invites-popup-invites-remaining' | translate: { invites: (maxInvites$ | async) - (addedUsers$ | async).length } }}
                    </div>
                </div>
                <div class="relative mx-0 row border border-light-grey-v2 invitees-box rounded p-2">
                    <div
                        *ngFor="let user of addedUsers$ | async; let index = index"
                        class="user-box relative px-3 mb-2 me-2 py-1 d-flex align-items-center justify-content-center"
                        (mouseenter)="onMouseEnter(index)"
                        (mouseleave)="onMouseLeave(index)"
                    >
                        <div class="icon icon-s me-2 text-white" inlineSVG="assets/icons-color.svg#person-grey"></div>
                        <div class="text-s">{{ user.name }}</div>
                        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                        <button
                            *ngIf="!user.sent"
                            class="icon icon-xxs ms-2 pointer"
                            inlineSVG="assets/icons-color.svg#remove"
                            (click)="removeUser(index)"
                            buttonDataTest="removeUsersButton"
                        ></button>
                        <div *ngIf="hoverIndex === index" class="user-email border border-lightest-grey p-2 text-s bg-white shadow-medium">
                            <ng-container *ngIf="!user.sent; else emailSent">
                                <div class="font-bold">{{ user.email }}</div>
                            </ng-container>
                            <ng-template #emailSent>
                                <div>
                                    <div class="d-flex align-items-center">
                                        <div class="text-s font-bold me-2" translate>v3-trial-invites-popup-invite-sent</div>
                                        <div class="d-flex align-items-center justify-content-center bg-light-shadow-v2 tick">
                                            <div class="icon icon-xxxs icon-white" inlineSVG="assets/icons.svg#tick"></div>
                                        </div>
                                    </div>
                                    <div class="text-s me-4 text-oneline">{{ user.email }}</div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Email -->
            <div class="mb-7 mt-5">
                <div class="text-m font-bold mb-3" translate>v3-global-email</div>
                <textarea class="w-100 mb-4" type="text" [formControl]="messageControl"></textarea>
            </div>

            <!-- Buttons -->
            <div class="d-flex mx-0 justify-content-center align-items-center theme-new mb-5">
                <button class="btn-clear text-m font-bold px-3 me-sm-6" (click)="closePopup()" translate>v3-button-cancel</button>

                <button
                    class="btn text-m font-bold send-btn"
                    (click)="sendInvites()"
                    [disabled]="!canSendInvites"
                    [ngClass]="[canSendInvites ? 'btn-secondary' : 'send-btn-disabled']"
                    translate
                >
                    v3-trial-invites-popup-send-invite
                </button>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #loader>
    <div class="py-8">
        <app-loader loaderColor="default"></app-loader>
    </div>
</ng-template>
